import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var learnerCourseDetailsRes;
export const learnerCourseDetailsTodo = createAsyncThunk('learnerCourseDetails', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner/learner_course_details',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "course_id": data.course_id,
                "fk_training_id": data.training_id,
                "device_token": user_id.vdevice_token
            },
            mode: 'no-cors',
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return learnerCourseDetailsRes = res.data
    } catch (error) {
        return learnerCourseDetailsRes = error.response.data
    }
})


const learnerCourseDetailsSlice = createSlice({
    name: 'learnerCourseDetails',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(learnerCourseDetailsTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('learnerCourseDetails', state.data)
            }
        });
        builder.addCase(learnerCourseDetailsTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default learnerCourseDetailsSlice.reducer; 